module.exports = __webpack_public_path__ + "static/media/kitchen-stool.56c96c31.png";